import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Device } from '@capacitor/device';
import { Network } from '@capacitor/network';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

export const useMobileFeatures = () => {
  const [isNative, setIsNative] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [networkStatus, setNetworkStatus] = useState(null);

  useEffect(() => {
    const initializeMobileFeatures = async () => {
      if (Capacitor.isNativePlatform()) {
        setIsNative(true);
        
        try {
          // Get device info
          const info = await Device.getInfo();
          setDeviceInfo(info);
          
          // Monitor network status
          const status = await Network.getStatus();
          setNetworkStatus(status);
          
          Network.addListener('networkStatusChange', (status) => {
            setNetworkStatus(status);
          });
        } catch (error) {
          console.error('Error initializing mobile features:', error);
        }
      }
    };

    initializeMobileFeatures();
  }, []);

  const getCurrentLocation = async () => {
    if (!isNative) return null;
    
    try {
      const coordinates = await Geolocation.getCurrentPosition();
      return coordinates;
    } catch (error) {
      console.error('Error getting location:', error);
      return null;
    }
  };

  const takePhoto = async () => {
    if (!isNative) return null;
    
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.Uri
      });
      return image;
    } catch (error) {
      console.error('Error taking photo:', error);
      return null;
    }
  };

  const triggerHaptic = async (style = ImpactStyle.Light) => {
    if (isNative) {
      try {
        await Haptics.impact({ style });
      } catch (error) {
        console.error('Error triggering haptic feedback:', error);
      }
    }
  };

  return {
    isNative,
    deviceInfo,
    networkStatus,
    getCurrentLocation,
    takePhoto,
    triggerHaptic
  };
}; 